import {
  DeliverectChannel,
  SALES_CHANNEL_TO_DELIVERECT_CHANNEL,
} from "~/domain/deliverect-channel";
import type { SalesChannel } from "~/domain/sales-channels";

export const toDeliverectChannel = (channel: SalesChannel): DeliverectChannel =>
  SALES_CHANNEL_TO_DELIVERECT_CHANNEL[channel] ??
  DeliverectChannel.WEB_ORDERING;
